import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CepPipe } from './cep.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ CepPipe ],
    exports: [ CepPipe ],
})
export class CepPipeModule {}
